<template>
  <div class="grid">
    <div class="header f-h f-ac m-tx4">
      <cdn-svg path="nucleo/handshake" class="h-x5 w-x5 m-rx1" />
      <div class="title t-lg bold">Donut Intros</div>
    </div>
    <user-settings-snooze-intros class="m-tx2" />
    <user-settings-working-hours class="m-tx3" />
    <user-settings-avoid-pairing class="m-tx3" />
  </div>
</template>
